<template>
  <div class="login">
    <div class="login-form-box">
      <form id="login_form" class="login-form">
        <dl class="login-dl">
          <dd>
            <span class="login-user" style=""></span>
            <input
              type="text"
              name="identity"
              placeholder="请输入用户名称"
              class="login-text"
            />
          </dd>
          <dd>
            <span
              class="login-pass"
              style="width: 40px; height: 40px; display: block; float: left"
            ></span>
            <input
              type="password"
              name="password"
              placeholder="请输入用户密码"
              class="login-text"
            />
          </dd>

          <dd class="login-submit" @click="login">登录</dd>
        </dl>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },

  computed: {},
  created() {},
  mounted() {},
  methods: {
    login() {
     
      localStorage.setItem("isLogin", "1");
      this.$router.push({
        name: "Home",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.login {
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-image: url("../../assets/image/login_bg.jpg");
  display: flex;
  position: relative;
  align-items: center;

  .login-form-box {
    background: url("../../assets/image/login/login-box.png") no-repeat;
    background-size: 100% 100%;
    width: rpx(440);
    height: rpx(400);
    margin: 0 auto;
    padding-top: 15px;
    position: absolute;
    right: 10%;
  }

  .login-form {
    width: 72%;
    margin: 7% auto 0 17%;
  }

  .login-dl {
    width: 100%;
  }

  .login-dl dd {
    border-bottom: 1px solid #255785;
    height: 3rem;
    margin-bottom: 40px;
    margin-left: 0;
    margin-right: 20px;
  }

  .login-user {
    margin-top: rpx(8);
    width: 40px;
    height: 40px;
    display: block;
    float: left;
    background: url("../../assets/image/login/login_user.png") no-repeat;
    background-size: 30px 30px;
  }

  .login-pass {
    margin-top: rpx(8);
    width: 40px;
    height: 40px;
    display: block;
    float: left;
    background: url("../../assets/image/login/login_pass.png") no-repeat;
    background-size: 25px 30px;
  }

  .login-text {
    float: left;
    font-size: 14px;
    height: 2rem;
    line-height: 2rem;
    padding: 8px 1%;
    width: calc(90% - 40px);
    text-indent: 2em;
    border: none;
    background: transparent;
    color: #fff;
    outline: none;
    margin-top: 5px;
  }

  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #1e4f9e;
    opacity: 1;
  }

  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #1e4f9e;
    opacity: 1;
  }

  input:-ms-input-placeholder {
    color: #1e4f9e;
    opacity: 1;
  }

  input::-webkit-input-placeholder {
    color: #1e4f9e;
    opacity: 1;
  }

  input:-webkit-autofill {
    height: rpx(20);
    border-radius: rpx(4);
  }

  .login-submit {
    margin-top: 25%;
    font-size: 22px;
    border: none;
    text-align: center;
    height: 2.6rem !important;
    line-height: 2.6rem;
    color: #fff;
    border-radius: 20px;
    background: linear-gradient(
      to bottom,
      rgba(134, 245, 255, 1) 0,
      rgba(45, 106, 228, 1) 100%
    );
    cursor: pointer;
  }

  .login-submit:hover {
    background: linear-gradient(
      to bottom,
      rgba(134, 245, 255, 1) 0,
      rgba(45, 106, 228, 0.7) 100%
    );
  }
}
</style>